import { useEffect } from 'react';
import GoogleMaps from '../GoogleMaps/GoogleMaps';
import styles from './shopfinder.module.scss';
import { GoogleMapsLayoutProps, IShopsOptions } from './types/propsTypes';

const GoogleMapsLayout = ({ setSelectedShop, shopLocations, selectedShop }: GoogleMapsLayoutProps) => {
  const configs = ConfigService.getConfigs();
  const assetsBasePath = configs.NEXT_ASSETS_BASE_PATH as string;
  const onMapStoreSelection = (storeId: string) => {
    setSelectedShop(storeId);
    scrollToElementInContainer(storeId);
  };

  const scrollToElementInContainer = (elementId: string) => {
    const container = document.getElementById('scrollableShopListContainer');
    const element = document.getElementById(elementId);
    if (!container || !element) {
      return;
    }
    // Calculate the offset of the element relative to the container
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    // Calculate the offset to scroll the container so that the element is centered
    const offset = elementRect.top - containerRect.top - containerRect.height / 2 + elementRect.height / 2;

    // Scroll the container to the calculated position
    container.scrollTo({
      top: container.scrollTop + offset,
      behavior: 'smooth',
    });
  };
  useEffect(() => {
    scrollToElementInContainer(selectedShop);
  }, [selectedShop]);

  return (
    <div className={styles['pickup-stores-google-map']}>
      {shopLocations ? (
        <GoogleMaps
          storeLocations={shopLocations?.map((shop: IShopsOptions) => ({
            id: shop.id,
            name: shop.name,
            lat: shop.lat ?? 0,
            lng: shop.lng ?? 0,
            storeName: shop.name,
            storeId: shop.id,
            storeAddress: shop.addressLine,
          }))}
          selectedStoreId={selectedShop}
          getUpdatedStoreId={onMapStoreSelection}
          customClass={`${styles['pickup-stores-google-map-view']}`}
          customMarkerURL={{
            defaultCustomMarkerURL: `${assetsBasePath}/images/bopis-map-pin-default.svg`,
            selectedMarkerURL: `${assetsBasePath}/images/bopis-map-pin-selected.svg`,
            scaledMarkerSize: {
              defaultMarkerSize: {
                height: 40,
                width: 30,
              },
              selectedMarkerSize: {
                height: 56,
                width: 42,
              },
            },
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default GoogleMapsLayout;
